import { styled } from "@mui/material/styles";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_BLUE } from "shared/theme/colors";

export const StyledAuthBadge = styled(FlexCenter)`
  background-color: ${COLOR_BLUE};
  border-radius: 0.75rem;
  column-gap: 0.25rem;
  padding: 0.25rem 0.5rem;
`;
